'use strict';

var Joi = require('joi');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var _Joi$string;
var appNames = ['discord', 'instagram', 'stripe', 'twitter', 'youtube', 'zapier'];
var DashboardAppInstallChange = Joi__default["default"].object().keys({
  app_name: (_Joi$string = Joi__default["default"].string()).valid.apply(_Joi$string, appNames).required().description('The name of the app integration the creator is installing/uninstalling'),
  install_change: Joi__default["default"].string().valid('install', 'uninstall').required().description('Describes whether the action taken by the creator was an install or uninstall')
}).description('dashboard:app_install_change event attributes ').meta({
  name: 'DashboardAppInstallChange',
  filename: 'dashboard:app_install_change.model'
});
var DashboardAppInstallChange$1 = DashboardAppInstallChange;

module.exports = DashboardAppInstallChange$1;
//# sourceMappingURL=app_install_change.model.js.map
